import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SequenceLinkedAsset_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, name: string, sequences?: Array<{ __typename?: 'LinkedSequence', sequenceId?: string | null, sequenceName?: string | null } | null> | null };

export type SequenceLinkedAsset_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, name: string };

export type SequenceLinkedAsset_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, name: string };

export type SequenceLinkedAsset_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, name: string };

export type SequenceLinkedAsset_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, name: string };

export type SequenceLinkedAsset_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, name: string };

export type SequenceLinkedAsset_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, name: string };

export type SequenceLinkedAsset_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, name: string };

export type SequenceLinkedAsset_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, name: string };

export type SequenceLinkedAsset_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, name: string, sequences?: Array<{ __typename?: 'LinkedSequence', sequenceId?: string | null, sequenceName?: string | null } | null> | null };

export type SequenceLinkedAsset_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, name: string, sequences?: Array<{ __typename?: 'LinkedSequence', sequenceId?: string | null, sequenceName?: string | null } | null> | null };

export type SequenceLinkedAssetFragment = SequenceLinkedAsset_AudioAsset_Fragment | SequenceLinkedAsset_DocumentAsset_Fragment | SequenceLinkedAsset_FileAsset_Fragment | SequenceLinkedAsset_FolderAsset_Fragment | SequenceLinkedAsset_ImageAsset_Fragment | SequenceLinkedAsset_InteractiveAsset_Fragment | SequenceLinkedAsset_InteractiveLiveAsset_Fragment | SequenceLinkedAsset_ModelAsset_Fragment | SequenceLinkedAsset_UnsupportedAsset_Fragment | SequenceLinkedAsset_VersionStackAsset_Fragment | SequenceLinkedAsset_VideoAsset_Fragment;

export const SequenceLinkedAsset = /*#__PURE__*/ gql`
    fragment SequenceLinkedAsset on Asset {
  id
  name
  ... on VideoAsset {
    sequences @client {
      sequenceId
      sequenceName
    }
  }
  ... on AudioAsset {
    sequences @client {
      sequenceId
      sequenceName
    }
  }
  ... on VersionStackAsset {
    sequences @client {
      sequenceId
      sequenceName
    }
  }
}
    ` as unknown as DocumentNode<SequenceLinkedAssetFragment, unknown>;

        

        
export const useSequenceLinkedAssetFragment = (
  input: string | Omit<UseFragmentOptions<SequenceLinkedAssetFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<SequenceLinkedAssetFragment>({
    fragment: SequenceLinkedAsset,
    fragmentName: 'SequenceLinkedAsset',
    ...options,
  });
};
  
        